<template>
  <div class="mob-remove-table-fixed">
    <Card shadow>
      <Modal
        v-model="exportModal"
        title="自定义导出">
        <Form ref="form" :model="form" :label-width="85"  :rules="ruleValidate">
          <FormItem label="选中所有字段">
            <Checkbox v-model="form.single" @on-change="ckChange">选中所有字段</Checkbox>
          </FormItem>
          <FormItem label="导出字段" prop="columns">
            <Select v-model="form.columns" placeholder="请选择导出字段" multiple>
              <Option v-for="item in tableColumnsSel" :key="item.key" :value="item.title" :label="item.title"></Option>
            </Select>
          </FormItem>
          <FormItem label="开始日期" prop="beginDate">
            <DatePicker v-model="form.beginDate" type="datetime" style="width:100%;" format="yyyy-MM-dd HH:mm:ss" :clearable="false"></DatePicker>
          </FormItem>
          <FormItem label="结束日期" prop="endDate">
            <DatePicker v-model="form.endDate"  type="datetime" style="width:100%;" format="yyyy-MM-dd HH:mm:ss" :clearable="false"></DatePicker>
          </FormItem>
        </Form>
        <div slot="footer">
          <Button type="primary" @click="ok" :loading="exportLoading">确认</Button>
          <Button  @click="cancelModal" >取消</Button>
        </div>
      </Modal>
      <Row>
        <Col style="text-align: left" :sm="16">
          <Form inline style="height: 41px">
            <FormItem label="需要我审批的" :label-width="90" class="mob-w-45">
              <i-switch v-model="tableSearchForm.need_i_approval" @on-change="tableSearchForm.need_i_build=false;getTableData()">
                <span slot="open"></span>
                <span slot="close"></span>
              </i-switch>
            </FormItem>
            <FormItem label="需要我发布的" :label-width="90" class="mob-w-45">
              <i-switch v-model="tableSearchForm.need_i_build" @on-change="tableSearchForm.need_i_approval=false; getTableData()">
                <span slot="open"></span>
                <span slot="close"></span>
              </i-switch>
            </FormItem>
          </Form>
        </Col>
        <Col style="text-align: right" :sm="8">
          <Button type="primary" @click="exportData"><Icon type="ios-download-outline"></Icon>自定义导出</Button>
          <Button
            style="float: right; margin-left: 10px; margin-bottom: 10px"
            @click="$router.push({ name: 'codeReleaseFlowAdd' })"
            type="primary"
            icon="md-add">申请代码发布</Button>
        </Col>
        <Divider/>
        <Form :model="tableSearchForm" ref="tableSearchForm" inline :label-width="60" @submit.native.prevent>
          <FormItem label="标题">
            <Input v-model="tableSearchForm.title" style="min-width: 200px" />
          </FormItem>
          <FormItem label="版本号">
            <Input v-model="tableSearchForm.version" style="min-width: 200px" />
          </FormItem>
          <!-- <FormItem label="发布模块">
            <Select v-model="tableSearchForm.module" placeholder="" filterable clearable transfer style="min-width: 200px">
              <Option v-for="item in moduleList" :key="item.id" :value="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem> -->
          <FormItem label="申请人">
            <Select v-model="tableSearchForm.applicant" placeholder="" filterable clearable transfer style="min-width: 200px">
              <Option v-for="item in userList" :key="item.id" :value="item.id">{{ item.name ? item.name : item.username }}</Option>
            </Select>
          </FormItem>
          <FormItem label="申请时间">
            <DatePicker type="daterange" placement="bottom-end" placeholder=""
                        v-model="tableSearchForm.created_at"
                        style="min-width: 200px"
                        @on-change="searchApplicationTimeChange"
                        class="mob-w-100"></DatePicker>
          </FormItem>
          <FormItem :label-width="0" class="mob-align-right">
            <Button type="primary" @click="getTableData()">搜索</Button>
            <Button style="margin-left: 8px" @click="clearSearchForm">重置</Button>
          </FormItem>
        </Form>
      </Row>
      <Alert v-if="listError" type="warning" show-icon>获取数据失败</Alert>
      <Table
        v-else
        border
        highlight-row
        :loading="tableLoading"
        ref="table"
        :data="table.data"
        :columns="table.columns"
        @on-sort-change="changeSort"></Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: left;">
          当前显示 {{ table.data.length }} 条记录，总共 {{ table.count }} 条记录
        </div>
        <div style="float: right;">
          <page
            :total="table.count"
            :current="table.page"
            :page-size="table.size"
            @on-change="getTableData"></page>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getCodeReleaseFlow, deleteCodeReleaseFlow, GetCodeReleaseExport } from '@/api/workflow/code_release_flow'
import { getModuleAllList } from '@/api/workflow/project'
import { GetALLUsers } from '@/api/user'
import moment from 'moment'
import dayjs from 'dayjs'
import excel from '@/libs/excel'
export default {
  name: 'list',
  data () {
    let that = this
    return {
      exportLoading: false,
      exportModal: false,
      tableColumnsSel: [
        {
          title: '标题',
          key: 'title'
        },
        {
          title: '项目',
          key: 'tenant_name'
        },
        {
          title: '版本号',
          key: 'version'
        },
        {
          title: '类型',
          key: 'type_name'
        },
        {
          title: '优先级',
          key: 'priority_verbose'
        },
        {
          title: '申请人',
          key: 'applicant'
        },
        {
          title: '申请时间',
          key: 'created_at'
        },
        {
          title: '状态',
          key: 'status_verbose'
        }
      ],
      form: {
        single: false,
        columns: [],
        beginDate: new Date(new Date().getTime() - 90 * 24 * 60 * 60 * 1000),
        endDate: new Date()
      },
      status: null,
      ordering: null,
      tableLoading: false,
      listError: false,
      table: {
        data: [],
        columns: [
          {
            title: '标题',
            key: 'title',
            align: 'center',
            tooltip: true,
            minWidth: 300
          },
          {
            title: '项目',
            key: 'tenant_name',
            align: 'center',
            tooltip: true,
            minWidth: 100
          },
          // {
          //   title: '发布模块',
          //   align: 'center',
          //   tooltip: true,
          //   minWidth: 100,
          //   render: (h, params) => {
          //     let tags = []
          //     for (let i in params.row.module) {
          //       const module = params.row.module[i]
          //       tags.push(
          //         h('Tag', module.name)
          //       )
          //     }
          //     return h('div', tags)
          //   }
          // },
          {
            title: '版本号',
            key: 'version',
            align: 'center',
            tooltip: true,
            minWidth: 200
          },
          {
            title: '类型',
            key: 'type_name',
            align: 'center',
            tooltip: true,
            minWidth: 100
          },
          {
            title: '优先级',
            key: 'priority_verbose',
            align: 'center',
            tooltip: true,
            minWidth: 100
          },
          {
            title: '申请人',
            key: 'applicant',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            render: (h, params) => {
              return h('span', params.row.applicant.name ? params.row.applicant.name : params.row.applicant.username)
            }
          },
          {
            title: '申请时间',
            key: 'created_at',
            align: 'center',
            tooltip: true,
            minWidth: 130,
            render: (h, params) => {
              if (params.row.created_at) {
                return h('span', moment(params.row.created_at).format('YYYY-MM-DD HH:mm:ss'))
              } else {
                return ''
              }
            }
          },
          {
            title: '状态',
            key: 'status_verbose',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            sortable: 'custom',
            render: (h, params) => {
              if (params.row.status_verbose) {
                return h('Tag', {
                  props: {
                    color: params.row.status_verbose === '已发布' ? 'green'
                      : params.row.status_verbose === '驳回' ? 'red'
                        : params.row.status_verbose === '回滚失败' ? 'red'
                          : params.row.status_verbose === '构建失败' ? 'red'
                            : params.row.status_verbose === '出错' ? 'red'
                              : params.row.status_verbose === '测试环境构建失败' ? 'red'
                                : params.row.status_verbose === '已回滚' ? 'yellow'
                                  : 'blue'
                  }
                }, params.row.status_verbose)
              } else {
                return ''
              }
            },
            filters: [
              {
                label: '待审批',
                value: 4
              },
              {
                label: '审批中',
                value: 5
              },
              {
                label: '待发布',
                value: 3
              },
              {
                label: '已发布',
                value: 9
              },
              {
                label: '线上验证通过',
                value: 30
              },
              {
                label: '线上验证不通过',
                value: 31
              },
              {
                label: '维护组验收通过',
                value: 32
              },
              {
                label: '维护组验收不通过',
                value: 33
              }
            ],
            filterMultiple: false,
            filterRemote (value, row) {
              if (value.length > 0) {
                that.status = value[0]
              } else {
                that.status = null
              }
              that.getTableData()
            }
          },
          {
            title: '操作',
            align: 'center',
            fixed: 'right',
            width: 150,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$router.push({ name: 'codeReleaseFlowDetail', params: { id: params.row.id }, query: { lastPage: this.table.page } })
                    }
                  }
                }, '详情'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    transfer: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  style: {
                    display: params.row.status === 4 && (this.$store.state.user.superuser || this.$store.state.user.userId === params.row.applicant.id) ? 'inline-block' : 'none'
                  },
                  on: {
                    'on-ok': () => {
                      this.delete(params.row.id)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 15
      },
      tableSearchForm: {
        title: '',
        version: '',
        applicant: '',
        module: '',
        created_at: '',
        created_at_after: '',
        created_at_before: '',
        need_i_approval: false,
        need_i_build: false
      },
      moduleList: [],
      userList: [],
      moment: moment
    }
  },
  created: function () {
    this.getTableData(this.$route.query.page ? parseInt(this.$route.query.page) : 1)
    this.getModuleList()
    this.getAllUserData()
  },
  methods: {
    changeSort (column) {
      if (column.key === 'status_verbose') {
        if (column.order === 'asc') {
          this.ordering = 'status'
        } else {
          this.ordering = '-status'
        }
      }
      this.getTableData()
    },
    getTableData (value = 1) {
      this.table.page = value
      this.tableLoading = true
      let reqParams = {
        size: this.table.size,
        page: this.table.page,
        title: this.tableSearchForm.title,
        version: this.tableSearchForm.version,
        applicant: this.tableSearchForm.applicant,
        created_at_after: this.tableSearchForm.created_at_after,
        created_at_before: this.tableSearchForm.created_at_before,
        need_i_approval: this.tableSearchForm.need_i_approval,
        need_i_build: this.tableSearchForm.need_i_build,
        ordering: this.ordering,
        status: this.status
      }
      if (this.tableSearchForm.module) {
        reqParams.module = this.tableSearchForm.module
      }
      getCodeReleaseFlow(reqParams).then(res => {
        let result = res.data
        this.table.data = result.results
        this.table.count = result.count
        this.tableLoading = false
        this.listError = false
      }).catch(res => {
        this.tableLoading = false
        console.log(res.response)
        this.listError = true
      })
    },
    delete (id) {
      deleteCodeReleaseFlow(id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getTableData(this.table.page)
      }).catch(res => {
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '删除失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '删除失败！'
          })
        }
      })
    },
    clearSearchForm () {
      this.tableSearchForm = {
        title: '',
        applicant: '',
        module: '',
        created_at: '',
        created_at_after: '',
        created_at_before: '',
        need_i_approval: this.tableSearchForm.need_i_approval,
        need_i_build: this.tableSearchForm.need_i_build
      }
    },
    // 获取模块列表
    getModuleList () {
      getModuleAllList().then(res => {
        this.moduleList = res.data
      })
    },
    // 获取所有用户数据
    getAllUserData () {
      GetALLUsers().then(res => {
        this.userList = res.data
      })
    },
    searchApplicationTimeChange (value) {
      this.tableSearchForm.created_at_after = value[0]
      this.tableSearchForm.created_at_before = value[1]
    },
    cancelModal () {
      this.form.single = false
      this.form.columns = []
      this.form.beginDate = new Date(new Date().getTime() - 90 * 24 * 60 * 60 * 1000)
      this.form.endDate = new Date()
      this.exportModal = false
    },
    ok () {
      // let that = this
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.exportLoading = true
          // let beginTime = dayjs(this.form.beginDate).format('YYYY-MM-DD HH:mm:ss')
          // let endTime = dayjs(this.form.endDate).format('YYYY-MM-DD HH:mm:ss')
          let beginTime = moment(this.form.beginDate).utc().format('YYYY-MM-DD HH:mm:ss')
          let endTime = moment(this.form.endDate).utc().format('YYYY-MM-DD HH:mm:ss')
          let params = {
            'c_time_after': beginTime,
            'c_time_before': endTime
          }
          GetCodeReleaseExport(params).then(res => {
            this.exportLoading = false
            console.log(res.data.length)
            if (res.data.length > 0) {
              // 把返回数据的utc时间转换为当地时间
              res.data.map(item => {
                item['created_at'] = item['created_at'] ? moment(item['created_at']).format('YYYY-MM-DD HH:mm:ss') : ''
              })
              const params = {
                title: this.form.columns,
                key: this.tableColumnsSel.filter((item, index) => this.form.columns.indexOf(item.title) > -1).map(m => m.key),
                data: res.data,
                autoWidth: true,
                filename: `代码发布导出-${dayjs(this.form.beginDate).format('YYYY-MM-DD')}.csv`
              }
              console.log(params)
              excel.export_array_to_excel(params)
            } else {
              this.$Message.info('表格数据不能为空！')
            }
          }).catch(res => {
            this.exportLoading = false
          })
        }
      })
    },
    // 自定义导出选中所有字段
    ckChange (val) {
      if (val) {
        this.form.columns = this.tableColumnsSel.map(item => item.title)
      } else {
        this.form.columns = []
      }
    },
    exportData () {
      this.exportModal = true
    }
  }
}
</script>

<style scoped>

</style>
